import React from 'react';
import Feature from '../../components/feature/Feature';
import './whatGPT3.css';

const WhatGPT3 = () => (
  <div className="gpt3__whatgpt3" id="wgpt3">
    <div className="gpt3__whatgpt3-feature">
      <Feature 
        title="Our Mission" 
        text="We aim to empower every student to reach their full potential through high-quality, personalized home tuition delivered with care, expert guidance and dedicated support." 
      />
    </div>
    <div className="gpt3__whatgpt3-heading">
      <h1 className="gradient__text">The possibilities are beyond your imagination</h1>
      <p>Start your learning journey</p>
    </div>
    <div className="gpt3__whatgpt3-container">
      <Feature 
        title="Classes" 
        text="Home tuition available from Nursery to Intermediate levels, tailored to each student's pace." 
      />
      <Feature 
        title="Subjects" 
        text="Expert teachers available for all academic and extracurricular subjects — science, maths, arts and more." 
      />
      <Feature 
        title="Locations" 
        text="Currently serving Noida, Ghaziabad, Indirapuram, and Delhi with plans to expand further." 
      />
    </div>
  </div>
);

export default WhatGPT3;
